function b(t) {
  const e = {
    category: "FormCompletionFeedback",
    action: t
  };
  return {
    submitFeedback: {
      ...e,
      label: "submit-feedback"
    },
    skipFeedback: {
      ...e,
      label: "skip-feedback"
    },
    thumbsUp: {
      ...e,
      label: "thumbs-up"
    },
    thumbsDown: {
      ...e,
      label: "thumbs-down"
    }
  };
}
const a = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getAnalyticsEvents: b
}, Symbol.toStringTag, { value: "Module" }));
export {
  b as g,
  a as h
};
